import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import {Field, reduxForm} from "redux-form";
import Dates from "../../../../classes/dates";
import axios from "axios";
import toastr from "toastr";
import Checkbox from "material-ui/Checkbox";
import MenuItem from "material-ui/MenuItem";
import OverlayTrigger from "react-bootstrap/lib/OverlayTrigger";
import Popover from "react-bootstrap/lib/Popover";
import {DatePicker, SelectField, TextField} from "redux-form-material-ui";
import Constants from "../../../../classes/constants"


const validate = (values) => {
    const errors = {};
    const requiredFields = ['AbscondedFrom', 'AbscondedTo'];

    if (values['AbscondedTo'] == null) {
        errors['AbscondedTo'] = 'Required';
    }
    requiredFields.forEach(field => {
      if (!values[field]) {
          errors[field] = 'Required'
      }
    });
return errors;
};


class ModalAbscond extends React.Component{
    constructor(props){
        super(props);

    }
    render(){
     const {handleSubmit, reset} = this.props;

     return(<Modal
     bsSize="large"
     show={this.props.open} onHide={this.props.close}>
     <Modal.Header closeButton>
       <Modal.Title><u>MOVE TO ABSCOND</u>
       </Modal.Title>
     </Modal.Header>

     <Modal.Body>
     <form onSubmit={handleSubmit(data=> {
          this.props.submitHandler(data);
        })}>

        <table style={{marginBottom: 0, width: '100%'}} className="table table-bordered">
            <tbody>
            <tr>
                <td style={{color: 'black', align: 'left', width: '18%'}}>Date Of Abscond:</td>
                <td style={{align: 'left', width: '28%', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtName" className="GenText">
                     <Field name="AbscondedFrom"
                            component={DatePicker}
                            formatDate={(date)=> {
                              return (date.toString().substring(0, 16));
                            }}
                            autoOk={true}
                            textFieldStyle={{width: '100%'}}
                            defaultValue={null} // DatePicker requires an object,
                       // and redux-form defaults to ''
                            hintText="Abscond From Date"/>
                  </span>
                </td>
                <td style={{color: 'black', align: 'left', width: '18%'}}>Date Till Abscond:</td>
                <td style={{align: 'left', padding: 0, paddingLeft: '1%'}}>
                  <span id="ContentPlaceHolder1_txtSpouseName" className="GenText">
                    <Field name="AbscondedTo"
                           fullWidth={true}
                           component={DatePicker}
                           formatDate={(date)=> {
                             return (date.toString().substring(0, 16));
                           }}
                           autoOk={true}
                           textFieldStyle={{width: '100%'}}
                           defaultValue={null} // DatePicker requires an object,// and redux-form defaults to ''
                           hintText="Abscond Till Date"/>
                    </span>
                </td>
            </tr>
            </tbody>
        </table>
        <br/>
        <button type="submit" style={{width: '25%', marginRight: '20px'}} className="btn btn-default">Submit
        </button>

    </form>
    </Modal.Body>
    </Modal>
    );
    }
}

ModalAbscond.propTypes = {};

export default reduxForm({
  form: 'applyAbscondManage',
  validate,

})(ModalAbscond)


/** WEBPACK FOOTER **
 ** ./src/feature/myProfile/ManagerSS/Modals/ModalAbscond.js
 **/